import axios from "axios"
let UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))

const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

export const sendReportOtpApi = async payload => {
    try {
      let apiToken = JSON.parse(localStorage.getItem("authUser"))
      const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
      }
  
      const response = await axios.post(
        `${apiBaseUrl}/send-report-otp`,
        payload,
        {
          headers,
        }
      )
      return response
    } catch (error) {
      console.error(error)
      throw error
    }
  }


  export const verifyReportOtpApi = async payload => {
    try {
      let apiToken = JSON.parse(localStorage.getItem("authUser"))
      const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
      }
  
      const response = await axios.post(
        `${apiBaseUrl}/verify-report-otp`,
        payload,
        {
          headers,
        }
      )
      return response
    } catch (error) {
      console.error(error)
      throw error
    }
  }